import get from 'lodash/get';
import { extend, override } from 'flarum/common/extend';

// Flarum components
import IndexPage from 'flarum/forum/components/IndexPage';
import UserPage from 'flarum/forum/components/UserPage';
import UserCard from 'flarum/forum/components/UserCard';
//import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import TextEditor from 'flarum/components/TextEditor';
import TerminalPost from 'flarum/forum/components/TerminalPost';
import humanTime from 'flarum/common/helpers/humanTime';
import icon from 'flarum/common/helpers/icon';
// custom components
import CustomFooter from './components/CustomFooter';
import CustomNavbar from './components/CustomNavbar';

const find = (obj, clazz) => obj && obj.children && obj.children.filter((e) => get(e, 'attrs.className', '').indexOf(clazz) !== -1)[0];

app.initializers.add('bj-community/bje-theme', () => {
  const footer = document.createElement('footer');
  const navbar = document.createElement('div');
  navbar.id = 'custom-navbar';

  // Button "Mark All as Read" is removed from the index page
  extend(IndexPage.prototype, 'actionItems', function (items) {
    items.remove('markAllAsRead');
  });

  // "neuer Beitrag" nicht auf Startseite anzeigen
  /*
  extend(IndexPage.prototype, 'sidebarItems', function (items) {
    if (items.has('newDiscussion') && app.current.data.routeName === 'index') {
      items.remove('newDiscussion');
    }
  });
  */

  // UserCard background color is changed to blue
  extend(UserCard.prototype, 'view', function (vnode) {
    vnode.attrs.style = { '--usercard-bg': '#005072' };
  });

  // UserCard background color is changed to blue
  extend(UserPage.prototype, 'view', function (vnode) {
    vnode.attrs.style = { '--usercard-bg': '#005072' };
  });

  // "Images" in Texteditor entfernen
  extend(TextEditor.prototype, 'markdownToolbarItems', function (items) {
    items.remove('image');
  });

  const RichtextEditor = require('@askvortsov-rich-text').components.ProseMirrorMenu
  extend(RichtextEditor.prototype, 'items', function (items) {
   items.remove('image');
  });

  override(TerminalPost.prototype, 'view', function (vdom) {
    const discussion = this.attrs.discussion;
    const lastPost = this.attrs.lastPost && discussion.replyCount();

    const user = discussion['user']();
    const time = discussion['createdAt']();

    return (
      <span>
        {app.translator.trans('core.forum.discussion_list.' + (lastPost ? 'replied' : 'started') + '_text', {
          user,
          ago: humanTime(time),
        })}
      </span>
    );
  });

  // Footer hinzufügen
  m.mount(document.body.appendChild(footer), CustomFooter);

  // Navigation hinzufügen
  m.mount(document.querySelector('header').appendChild(navbar), CustomNavbar);
});
